import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
//import axios from 'axios'

// Initial State
const initialState = {
    loading: false,
    error: null,
    token: null,
}

/* // Login action
export const loginUserAction = createAsyncThunk(
    'user/login',
    async (values) => {
        try {
            // Make HTTP request
            const response = await axios.post(`/api/v1/user/login`, values, {
                headers: { "Content-Type": 'application/json' },
            })

            // Save the user data in local storage
            //localStorage.setItem('user', JSON.stringify(data))

            return response.data

        } catch (error) {
            return error?.response?.data
        }
    }
) */

// User Slice

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        login: (state, action) => {
            state.loading = false
            state.error = null
            state.token = action.payload.token
        },
        logout: (state) => {
            state.loading = false
            state.error = null
            state.token = null
        },
    },
    /* extraReducers: (builder) => {
        // Handle Actions
        // Login
        builder.addCase(loginUserAction.pending, (state) => {
            state.loading = true
            state.error = null
        })
        builder.addCase(loginUserAction.fulfilled, (state, action) => {
            state.token = action.payload.token
            state.loading = false
        })
        builder.addCase(loginUserAction.rejected, (state, action) => {
            state.error = action.payload
            state.loading = false
        })
    } */
})

export const { login, logout } = userSlice.actions

// Generate Reducer
const userReducer = userSlice.reducer

export default userReducer